module.exports = __webpack_public_path__ + "img/kn21_samurai01.a237aab0.png";